export * from '@primeuix/themes/lara/panelmenu';
export { default } from '@primeuix/themes/lara/panelmenu';
